export default __webpack_public_path__ + "static/media/attraction3.1fd6710b.jpg";